'use client';

import { LuSearch } from 'react-icons/lu';
import { cn } from '@core/helpers/misc/GeneralUtils';
import { Kbd, KbdGroup } from '@core/ui/primitives/kbd';
import { useSearch } from '@/features/search/ui/SearchProvider';

/**
 * SearchButton - Search trigger button for the navigation bar
 *
 * Opens the search dialog when clicked. Shows keyboard shortcut (⌘K / Ctrl+K).
 */
export function SearchButton() {
  const { openSearch } = useSearch();

  return (
    <button
      onClick={openSearch}
      className={cn(
        'search-button h-9 flex items-center gap-2 px-3 rounded-lg transition-colors',
        'text-muted-foreground hover:text-foreground hover:bg-accent'
      )}>
      <LuSearch className='search-button__icon h-5 w-5' />
      <KbdGroup className='search-button__shortcut'>
        <Kbd size='sm' keys={['meta']} />
        <Kbd size='sm' keys={['k']} />
      </KbdGroup>
    </button>
  );
}

export default SearchButton;
